import { Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { ChatRoomMessagesService } from '../_services/chat-room-messages.service';
import { ChatRoomsService } from '../_services/chat-rooms.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { ChatRoom } from '../_types/chat-room';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { firstValueFrom } from 'rxjs';
import { LocalStorageService } from 'angular-web-storage';
import { ChatRoomUsersService } from '../_services/chat-room-users.service';
import moment from 'moment';
import 'moment/locale/es';
import { ChatService } from '../_services/chat.service';
import { User } from '../../users/_types/user';
import { WhatsappMessageService } from '../../comunications/_services/whatsapp-messages.service';
import { WhatsappChatService } from '../../whatsapp/_services/whatsapp-chat.service';



@Component({
    selector: 'app-chat-list',
    templateUrl: './chat-list.component.html',
    styleUrls: ['./chat-list.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ChatListComponent {

  public unreadChats: ChatRoom[] = [];
  public chats: any[] = [];
  public unreadWhatsapp: any[] = [];
  constructor(
      private chatRoomsService: ChatRoomsService, 
    private chatservice: ChatService,
    private whatsappMessageService: WhatsappMessageService,
    private whatsappChatService: WhatsappChatService,
    private storage: LocalStorageService) { }
    public user: User = this.storage.get('user');

  ngOnInit() {
    this.chatservice.onOpenListChats.subscribe((info:any) => {
      //("onOpenListChats");
      this.loadData();
    });

    //al abrir un chat de whatsapp sus entrantes quedan leidos, asi que recargamos para que dejen de
    //aparecer como pendientes sin tener que cerrar y volver a abrir el panel
    this.whatsappMessageService.onWhatsappReaded.subscribe(() => {
      this.loadUnreadWhatsapp();
    });
  }

  async loadData(){
    this.user=this.storage.get('user');
   
    //los chats que tiene mensajes sin leer por el usuario
    this.unreadChats = await firstValueFrom(this.chatRoomsService.GetUnread(true));

    //los chats que tienen mensajes en los ultimos 7 dias
    this.chats = await firstValueFrom(this.chatRoomsService.GetLastChats(7));

    //los whatsapp entrantes pendientes de leer que me corresponden
    await this.loadUnreadWhatsapp();
  }

  async loadUnreadWhatsapp(){
    this.unreadWhatsapp = await firstValueFrom(this.whatsappMessageService.GetUnread());
  }

  async goTo(chat: any){
    this.chatservice.openChatRoom(chat.code, chat.title);

    //borramos el contador de chats sin leer de la cache local
    this.storage.remove("chatsNotReaded");
  }

  async goToWhatsapp(message: any){
    //el propio chat marca como leidos los entrantes de este telefono al abrirse
    this.whatsappChatService.open(message.phoneNumber, message.clientName, message.caseId);
    this.storage.remove("chatsNotReaded");
  }
}
